// src/components/profile/ProfileTabs.jsx
import React from "react";
import { Paper, Tabs, Tab, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline"; // Account
import SchoolIcon from "@mui/icons-material/School"; // Certifications
import PlaceIcon from "@mui/icons-material/Place"; // My Divesites
import ShareIcon from "@mui/icons-material/Share"; // Shared Dives
import PermMediaIcon from "@mui/icons-material/PermMedia"; // My Media
import SettingsIcon from "@mui/icons-material/Settings"; // Preferences

const ProfileTabs = ({ tabValue, handleTabChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: isMobile ? 1 : 2,
        mb: isMobile ? 2 : 4,
        border: `1px solid ${theme.palette.divider}`,
        mx: isMobile ? 1 : 0,
        backgroundColor: theme.palette.background.paper, // Match card background
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="profile sections tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          px: isMobile ? 1 : 2,
          minHeight: isMobile ? 48 : "auto",
          "& .MuiTabs-indicator": {
            height: isMobile ? 2 : 3,
            backgroundColor: theme.palette.primary.main, // Ensure indicator color adapts
          },
          "& .MuiTabs-scrollButtons": {
            color: theme.palette.primary.main,
            "&.Mui-disabled": {
              opacity: 0.3,
            },
          },
          "& .MuiTab-root": {
            minWidth: isMobile ? 80 : 120,
            padding: isMobile ? theme.spacing(1, 0.5) : theme.spacing(2, 2),
            fontSize: isMobile ? "0.75rem" : "0.875rem",
            fontWeight: "medium",
            color: theme.palette.text.secondary, // Default tab text color

            "&.Mui-selected": {
              color: theme.palette.primary.main, // Selected tab text color
              fontWeight: "bold",
            },

            // Icon positioning for mobile
            ...(isMobile && {
              flexDirection: "column",
              "& .MuiTab-iconWrapper": {
                marginBottom: theme.spacing(0.5),
                marginRight: 0,
              },
            }),

            // Tablet adjustments
            ...(isTablet &&
              !isMobile && {
                minWidth: 100,
                padding: theme.spacing(1.5, 1),
              }),
          },
        }}
      >
        <Tab
          icon={<PersonOutlineIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="Account"
        />
        <Tab
          icon={<SchoolIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="Certifications"
        />
        <Tab
          icon={<PlaceIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="My Divesites"
        />
        <Tab
          icon={<ShareIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="My Dives"
        />
        <Tab
          icon={<PermMediaIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="My Media"
        />
        <Tab
          icon={<SettingsIcon sx={{ fontSize: isMobile ? 18 : 24 }} />}
          label="Preferences"
        />
      </Tabs>
    </Paper>
  );
};

export default ProfileTabs;
